import moment from "moment";
moment.updateLocale("es", {
    week: {
        dow: 1,
    },
});
const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
];
const formatDate = (date) => {
    return `${moment(date).format("DD")} de ${months[moment(date).month()]}`;
};
export const getWeeksBetweenDates = (startDate, endDate) => {
    let currentDate = moment(startDate).startOf("week");
    let weeksInBetween = [];
    if (moment(startDate).isSame(moment(startDate).startOf("month"))) {
        weeksInBetween.push(formatDate(startDate));
    }
    while (moment(currentDate).isSameOrBefore(endDate, "week")) {
        if (moment(currentDate).isSameOrAfter(startDate)) {
            weeksInBetween.push(formatDate(currentDate));
        }
        currentDate = moment(currentDate).add(1, "week");
    }
    return weeksInBetween;
};
